import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=bd8ed702&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"
import style0 from "./Number.vue?vue&type=style&index=0&id=bd8ed702&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ed702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd8ed702')) {
      api.createRecord('bd8ed702', component.options)
    } else {
      api.reload('bd8ed702', component.options)
    }
    module.hot.accept("./Number.vue?vue&type=template&id=bd8ed702&scoped=true", function () {
      api.rerender('bd8ed702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BigNumber/Number.vue"
export default component.exports